module.exports = __webpack_public_path__ + "img/Certificate.ca494c01.jpg";